import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import "./modal.scss";

// interface to declare all our prop types
interface Props {
  title?: any;
  onClose?: any;
  initialHeight?: any;
  size?: any;
  children: React.ReactNode;
}

const Modal: React.FC<Props> = ({
  title,
  onClose,
  initialHeight,
  size,
  children,
  ...rest
}) => {
  const [visible, setVisible] = React.useState(true);
  
  const toggleDialog = () => {
    setVisible(!visible);
  };

  return (
    <Dialog title={title} onClose={onClose} className={size}>
      {children}
    </Dialog>
  );
};

export default Modal;
